module.exports = __webpack_public_path__ + "img/truckTrailerRearRightOutline.aff40233.svg";